import { useNavigate } from "react-router-dom";
import { ChevronDown, Wallet, MessageCircle, Sparkles, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useChat } from "@/context/ChatContext";
import { canOpen } from "@/components/shell/navConfig";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const strumentiFor = (user, apps, chatInternal) => [
  canOpen(user, apps, "/foglio-cassa") && { to: "/foglio-cassa", label: "Foglio Cassa", icon: Wallet },
  chatInternal && { to: "/chat", label: "Chat interna", icon: MessageCircle },
  { to: "/novita", label: "Archivio novità", icon: Sparkles },
  user?.role === "admin" && { to: "/admin", label: "Pannello Admin", icon: ShieldCheck },
].filter(Boolean);

export const StrumentiMenu = () => {
  const { user, apps } = useAuth();
  const { isInternal } = useChat();
  const nav = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="strumenti-menu-btn" className="flex items-center gap-1.5 h-9 px-3 rounded-lg text-sm font-medium text-slate-700 hover:text-navy hover:bg-sage transition-colors">
          Strumenti <ChevronDown className="h-3.5 w-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {strumentiFor(user, apps, isInternal).map((s) => (
          <DropdownMenuItem key={s.to} onClick={() => nav(s.to)} className="cursor-pointer" data-testid={`strumenti-${s.to.slice(1)}`}>
            <s.icon className="h-4 w-4 mr-2 text-navy" /> {s.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
